var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "icons" }, [
    _c("div", { staticClass: "forcast-icon-wrapper" }, [
      _vm.bigEye === 1
        ? _c("img", {
            attrs: {
              src: require("@/assets/svg/chart-icons/player-outline.svg"),
              alt: "Big eye forcast",
            },
          })
        : _vm._e(),
      _vm.bigEye === 0
        ? _c("img", {
            attrs: {
              src: require("@/assets/svg/chart-icons/banker-outline.svg"),
              alt: "Banker count",
            },
          })
        : _vm._e(),
    ]),
    _c("div", { staticClass: "forcast-icon-wrapper" }, [
      _vm.smallRoad === 1
        ? _c("img", {
            attrs: {
              src: require("@/assets/svg/chart-icons/player-filled.svg"),
              alt: "Small road forcast",
            },
          })
        : _vm._e(),
      _vm.smallRoad === 0
        ? _c("img", {
            attrs: {
              src: require("@/assets/svg/chart-icons/banker-filled.svg"),
              alt: "Banker count",
            },
          })
        : _vm._e(),
    ]),
    _c("div", { staticClass: "forcast-icon-wrapper" }, [
      _vm.cockroachRoad === 1
        ? _c("img", {
            attrs: {
              src: require("@/assets/svg/chart-icons/player-line.svg"),
              alt: "Cockroach Road forcast",
            },
          })
        : _vm._e(),
      _vm.cockroachRoad === 0
        ? _c("img", {
            attrs: {
              src: require("@/assets/svg/chart-icons/banker-line.svg"),
              alt: "Banker count",
            },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }